export default __webpack_public_path__ + "static/media/vjcet2.cd67f26d.png";